import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

/**
 * Basic select dropdown component that handles undefined values gracefully
 *
 * @param {string} label - The label for the select dropdown
 * @param {Array} itemList - List of items to display in the dropdown
 * @param {string|number} selectedValue - The currently selected value
 * @param {Function} onValueChange - Callback function when value changes
 * @param {boolean} [disabled=false] - Whether the select should be disabled
 * @returns {JSX.Element} - Rendered select component
 */
const BasicSelect = ({
  label,
  itemList,
  selectedValue,
  onValueChange,
  disabled = false,
}) => {
  // Convert undefined to empty string to avoid MUI warnings
  const safeSelectedValue = selectedValue === undefined ? "" : selectedValue;
  const [selectedItem, setSelectedItem] = useState(safeSelectedValue);

  useEffect(() => {
    // Reset the value when the selected value changes
    // Convert undefined to empty string to avoid MUI warnings
    const safeValue = selectedValue === undefined ? "" : selectedValue;
    setSelectedItem(safeValue);
  }, [selectedValue]);

  const handleChange = (event) => {
    // Only handle change if not disabled
    if (!disabled) {
      const newValue = event.target.value;
      setSelectedItem(newValue);
      onValueChange(newValue);
    }
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl
        fullWidth
        disabled={disabled}
      >
        <InputLabel id={`demo-simple-select-label-${label}`}>
          {label}
        </InputLabel>
        <Select
          labelId={`demo-simple-select-label-${label}`}
          id={`demo-simple-select-${label}`}
          value={selectedItem}
          label={label}
          onChange={handleChange}
          disabled={disabled}
        >
          {itemList.map((item) => {
            // Check if the option should be visible based on the selected value
            if (item.showWhen === undefined || item.showWhen) {
              return (
                <MenuItem
                  key={item.value}
                  value={item.value}
                >
                  {item.label}
                </MenuItem>
              );
            }
            return null;
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

export default BasicSelect;
